var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('div',{staticClass:"style-injector",domProps:{"innerHTML":_vm._s(_vm.style)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }